// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollableWindow from './components/ScrollableWindow';
import AboutPage from './pages/AboutPage';
import { projectRegistry } from './content/projectRegistry';
import { ThemeProvider, useTheme } from './theme/ThemeContext';
import Button from './components/Button';
import { MoonIcon, SunIcon } from './icons/navigationIcons';

function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    return (
        <div className="theme-toggle-fixed" style={{ position: 'fixed', top: 24, right: 24, zIndex: 1000 }}>
            <div className="tooltip-wrapper">
                <Button
                    variant="icon"
                    aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
                    onClick={toggleTheme}
                    icon={theme === 'light' ? <MoonIcon /> : <SunIcon />}
                />
                <span className="tooltip-text">
                    {theme === 'light' ? 'Dark mode' : 'Light mode'}
                </span>
            </div>
        </div>
    );
}

function App() {
    return (
        <ThemeProvider>
            <Router>
                <ThemeToggle />
                <Routes>
                    <Route path="/" element={<ScrollableWindow />} />
                    {projectRegistry.map(({ path, component: Component }) => (
                        <Route key={path} path={path} element={<Component />} />
                    ))}
                    <Route path="/about-page" element={<AboutPage />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;